export const goToThemesEditor = () => {
    open(
        `shopify://admin/themes/current/editor?context=apps&template=index&activateAppId=${
            import.meta.env.VITE_APP_CLIENT_ID
        }/pickup-app-embed-block`,
        '_blank'
    );
};
